var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3998 1.3998C11.6998 1.0998 12.1998 1.0998 12.5998 1.3998L22.5998 9.3998C22.9998 9.7998 23.0998 10.3998 22.7998 10.7998C22.5998 11.0998 22.2998 11.1998 21.9998 11.1998C21.7998 11.1998 21.5998 11.0998 21.3998 10.9998L20.9994 10.6808L20.9998 19.9998C20.9998 21.6391 19.791 22.9064 18.1804 22.9949L17.9998 22.9998H5.99982C4.29982 22.9998 2.99982 21.6998 2.99982 19.9998L2.99939 10.6808L2.59982 10.9998C2.23059 11.2767 1.60574 11.2128 1.27584 10.8867L1.19982 10.7998C0.899824 10.3998 0.999824 9.7998 1.39982 9.3998L11.3998 1.3998ZM11.9998 3.4998L4.99939 9.0848L4.99982 19.9998C4.99982 20.5569 5.34472 20.9416 5.87439 20.9938L5.99982 20.9998H7.99982V13.9998C7.99982 12.9454 8.8157 12.0816 9.85056 12.0053L9.99982 11.9998H13.9998C15.0542 11.9998 15.918 12.8157 15.9943 13.8505L15.9998 13.9998V20.9998H17.9998C18.5998 20.9998 18.9998 20.5998 18.9998 19.9998L18.9994 9.0848L11.9998 3.4998ZM13.9998 13.9998H9.99982V20.9998H13.9998V13.9998Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconHome.08ce436b2af0c77de64771bf0da47448.svg";